import produce from "immer";
import { LoadState } from "../../../constants/enums";
import {
  IRecurringInvoiceState,
  initialRecurringInvoiceState,
} from "./RecurringInvoice.types";
import {
  FETCH_RECURRING_INVOICES_LIST_PROGRESS,
  FETCH_RECURRING_INVOICES_LIST_SUCCESS,
  FETCH_RECURRING_INVOICES_LIST_FAILED,
  FETCH_RECURRING_INVOICE_PROGRESS,
  FETCH_RECURRING_INVOICE_SUCCESS,
  FETCH_RECURRING_INVOICE_FAILED,
  CLEAR_RECURRING_INVOICE_STATE,
} from "./RecurringInvoiceActions";
import { AnyAction } from "redux";

export const RecurringInvoiceReducer = (
  state: IRecurringInvoiceState = initialRecurringInvoiceState,
  action: AnyAction
) => {
  switch (action.type) {
    case FETCH_RECURRING_INVOICES_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_RECURRING_INVOICES_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.Loaded;
        draftState.list = data;
        draftState.totalRecords = totalRecords;
      });
      return newState;
    }

    case FETCH_RECURRING_INVOICES_LIST_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.Failed;
        draftState.error = errorMessage;
      });
      return newState;
    }

    case FETCH_RECURRING_INVOICE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.dataLoading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_RECURRING_INVOICE_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.dataLoading = LoadState.Loaded;
        draftState.data = data;
      });
      return newState;
    }

    case FETCH_RECURRING_INVOICE_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.dataLoading = LoadState.Failed;
        draftState.error = errorMessage;
      });
      return newState;
    }

    case CLEAR_RECURRING_INVOICE_STATE: {
      return initialRecurringInvoiceState;
    }

    default:
      return state;
  }
};
